import Config from "legacy/config";
import SyncableModel from "shared/syncable_model";

export default class DestinationCampaign extends SyncableModel {
  constructor(config) {
    const advertiserCampaignId = config.advertiserCampaignId;
    super({ "friendlyNameField": "text", "uniqueNameField": advertiserCampaignId });
    this.originalAdvertiserCampaignId = config.originalAdvertiserCampaignId;
    this.originalAffiliateId = config.originalAffiliateId;
    this.advertiserCampaignId = config.advertiserCampaignId;
    this.affiliateCampaignId = config.affiliateCampaignId;
    this.advertiserLabel = Config.localization.advertiserNameFromNetwork.name;
    this.affiliateLabel = Config.localization.affiliateNameFromNetwork.name;
    this.advertiserCampaignUrl = config.destinationAdvertiserCampaignUrl;
    this.affiliateCampaignUrl = this.buildAffiliateUrl(config.affiliateUrlBase);
  }

  buildAffiliateUrl(urlBase) {
    if (this.advertiserCampaignId) {
      const paramString = this.affiliateUrlParams();
      return `${urlBase}&${paramString}`;
    }
  }

  affiliateUrlParams() {
    const params = {
      "advertiser_campaign_id": this.advertiserCampaignId,
      "status": "Approved"
    };

    const paramsStrings = Object.keys(params).map((paramKey) => {
      return `${paramKey}=${params[paramKey]}`;
    });

    return paramsStrings.join("&");
  }

  requiresAffiliate() {
    return !!this.originalAffiliateId;
  }

  saveData() {
    return {
      advertiser_campaign_id: this.advertiserCampaignId,
      affiliate_campaign_id:  this.affiliateCampaignId
    };
  }

  validate() {
    const destinationInvalidError = this._validateDestination();
    const destinationMissingError = this._incompleteError();

    if (destinationInvalidError || destinationMissingError) {
      return {
        destinationError: destinationInvalidError,
        incompleteError: destinationMissingError
      };
    } else {
      return {};
    }
  }

  _validateDestination() {
    const errorMessage = "Destination cannot be the same as the Promo Number's current campaign";

    if (this.advertiserCampaignId === this.originalAdvertiserCampaignId.toString()) {
      if (this.originalAffiliateId) {
        if (this.originalAffiliateId.toString() === this.affiliateCampaignId) {
          return errorMessage;
        }
      } else {
        return errorMessage;
      }
    }
  }

  _incompleteError() {
    if (this.advertiserCampaignId) {
      if (this.requiresAffiliate() && !this.affiliateCampaignId) {
        return `${this.affiliateLabel} Campaign must be selected`;
      }
    } else {
      return `Campaign must be selected`;
    }
  }
}
